import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { MenuItems } from '../menu-items/menu-items';
import { trigger, state, style, animate, transition, stagger, query } from '@angular/animations';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'enterAnimation', [
        state('void', style({ opacity: 0, transform: 'translateX(100px)' })),
       transition('void => *',  [
        animate('700ms {{delay}}ms ease-out', style({
          opacity: 1,
          transform: 'translateX(0)'
        }))
      ], { params: { delay: 500 } }),
      ]
    ),
    // add animation stagger
   
  ],
})
export class PageTitleComponent {
  @Input() menuState!: string;
  @Input() pageSubtitle!: string;
  @Input() pageTitle!: string;
  @Input() animate: boolean = true;
  pagetitle!: string;
  
  constructor(private menuItems: MenuItems,
    private cdr: ChangeDetectorRef
  ) {
  }
  ngOnInit(): void {
    if (this.menuState) {
      this.pageTitle = this.menuItems.getPageTitle(this.menuState);
    } 
  }
  ngOnChanges(change: SimpleChanges): void {
    if (change['menuState'] && change['menuState'].currentValue) {
      this.pageTitle = change['menuState'].currentValue;
    }
    if (change['pageTitle'] && change['pageTitle'].currentValue) {
      this.pageTitle = change['pageTitle'].currentValue;
    }
    if (change['pageSubtitle'] && change['pageSubtitle'].currentValue) {
      this.pageSubtitle = change['pageSubtitle'].currentValue;
    }
    // this.cdr.detectChanges();
  }

  triggerAnimationIfAnimationsAreEnabled() {
    if (this.animate) {
      return true;
    }
    return false;
  }

}
